import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="container mt-5 pt-5 mb-5">
      <h1>Refund Policy</h1>
      <p className="text-muted">Last Updated: April 2026</p>
      
      <section className="mt-4">
        <h3>1. General Policy (All Sales Final)</h3>
        <p>
          As an e-commerce platform, all sales made on our website are considered final. 
          By default, we do not offer returns, exchanges, or refunds for any products 
          purchased through our site.
        </p>

        <h3 className="mt-4">2. Product-Specific Exceptions</h3>
        <p>
          Certain products may have their own unique return or refund policy. If a product is 
          eligible for a refund, return, or exchange, this exception will be <strong>explicitly 
          stated on that specific product's page</strong>. 
        </p>
        <p>
          If no return or refund policy is mentioned on the product page, our general "all sales final" 
          policy strictly applies.
        </p>

        <h3 className="mt-4">3. Damaged or Defective Items</h3>
        <p>
          If you receive an item that is defective, damaged upon arrival, or incorrect, please 
          contact our support team immediately. You may be asked to provide proof of the defect or 
          damage (such as clear photographs or videos) so we can evaluate the issue and assist you accordingly.
        </p>

        <h3 className="mt-4">4. Contact Us</h3>
        <p>
          If you have any questions regarding a specific product's refund eligibility before making 
          a purchase, please reach out to us at <strong>info@trustglobal.com.bd</strong>.
        </p>
      </section>
    </div>
  );
};

export default RefundPolicy;